import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { SpecialtyAttendanceResponse } from '../../responses/flow/specialty-attendance.response';

@Injectable({
  providedIn: 'root'
})
export class LookupService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public listSpecialtyAttendance(): Observable<SpecialtyAttendanceResponse> {

    let uri = `Lookup/SpecialtyAttendance`

    return this.httpClient.get<SpecialtyAttendanceResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiFlow) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}